import { number, struct } from 'io-ts/lib/Decoder';

export const FloorLevelAlignment = struct({
	horizontalOffsetPx: number,
	verticalOffsetPx: number,
});
